import { render } from "./TheCarsDetails.vue?vue&type=template&id=9b6be324"
import script from "./TheCarsDetails.vue?vue&type=script&lang=js"
export * from "./TheCarsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__